import { useContext } from "react";
import { FormContext } from "../formContext";
import { useOnDismount, useOnMount } from "@hooks";

export const useHideButton = () => {
  const { button: {setHidden} } = useContext(FormContext);

  useOnMount(() => {
    setHidden(true);
  });

  useOnDismount(() => {
    setHidden(false);
  });
};